import { createSelector } from 'reselect';
import moment from 'moment';
import naturalSort from '../utils/natural-sort';


const getOrdersStartDate = state => state.orders.ordersStartDate;
const getOrdersEndDate = state => state.orders.ordersEndDate;
const getOrders = state => state.orders.orders;
const getLastUpdate = state => state.orders.lastUpdate;
const getSelectedMode = state => state.orders.selectedMode;
const getOrderHistory = state => state.orders.orderhistory;
const getRouteStops = state => state.orders.routestops;
const getRoutePlanning = state => state.orders.routeplanning;
const getOrdersProductionPlace = state => state.orders.ordersProductionPlace;
const getOrderSpot = state => state.orders.orderSpot;
const getLocalSettings = state => state.app.localSettings;

export const getVisibleOrders = createSelector(
  [getOrdersStartDate, getOrdersEndDate, getOrders, getSelectedMode, getOrderHistory, getRouteStops, getRoutePlanning, getOrdersProductionPlace, getOrderSpot, getLocalSettings],
  (ordersStartDate, ordersEndDate, orders, selectedMode, orderhistory, routestops, isRoutePlanning, ordersProductionPlace, orderSpot, localSettings) => filterOrders(ordersStartDate, ordersEndDate, selectedMode, orders, orderhistory, isRoutePlanning, routestops, ordersProductionPlace, orderSpot, localSettings),
);

export const filterOrders = (startDate, endDate, modeId, orders, orderhistory, isRoutePlanning, routestops, ordersProductionPlace, orderSpot, localSettings) => {
  let filteredOrders = orders.asMutable();

  if (localSettings && localSettings.showProductionPlaceFilter && (ordersProductionPlace || ordersProductionPlace === 0)) {
    filteredOrders = filteredOrders.filter(o => o.productionPlaceId === ordersProductionPlace);
  }

  if (localSettings && localSettings.showOrderSpotFilter && (orderSpot || orderSpot === 0)) {
    filteredOrders = filteredOrders.filter(o => o.spotName === orderSpot);
  }

  if (isRoutePlanning) {
    filteredOrders = filteredOrders.filter(o => o.isDelivery);
  }

  if (localSettings && localSettings.sortSpotAlphabetical) {
    filteredOrders = naturalSort(filteredOrders, 'spotName');
  }

  if (modeId === 'Ueberfaellig') {
    startDate = moment().add(-100, 'years').toDate();
    endDate = moment().add(-1, 'day').endOf('day').toDate();
  }

  switch (modeId) {
    case 'Verlauf':
      filteredOrders = orderhistory.asMutable().reverse();
      break;
    case 'Morgen':
      filteredOrders = filteredOrders.filter(o => moment(o.pickupTimeNumeric).isAfter(moment().startOf('day').add(1, 'day')) && moment(o.pickupTimeNumeric).isBefore(moment().endOf('day').add(1, 'day')));
      break;
    case 'Uebermorgen':
      filteredOrders = filteredOrders.filter(o => moment(o.pickupTimeNumeric).isAfter(moment().startOf('day').add(2, 'day')) && moment(o.pickupTimeNumeric).isBefore(moment().endOf('day').add(2, 'day')));
      break;
    case 'Route':
      filteredOrders = isRoutePlanning ? filteredOrders : filteredOrders.filter(o => routestops.includes(o.id));
      break;
    case 'day':
      filteredOrders = filteredOrders.filter(o => moment(o.pickupTimeNumeric).isAfter(moment().startOf('day')) && moment(o.pickupTimeNumeric).isBefore(moment().endOf('day')));
      break;
    default:
      filteredOrders = filteredOrders.filter(o => moment(o.pickupTimeNumeric).isAfter(moment(startDate)) && moment(o.pickupTimeNumeric).isBefore(moment(endDate)));
  }
  return filteredOrders;
};

export default getVisibleOrders;
